<template>
  <div class="main">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"> <router-link to="/console">创作者中心</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">图文生成</li>
      </ol>
    </nav>
    <ul class="icon-list ps-0">
      <li class="d-flex align-items-start mb-1" v-for="link in links" :key="link.url"><a target="_blank"
          :href="'https://cloud.salesmini.cn' + link.url">{{ link.title
          }}</a></li>
    </ul>
  </div>
</template>
<script>
import sx from "../../utils/core.js";
// Import jquery
import $ from 'jquery'

// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $
export default {
  data() {
    return {
      links: []
    }
  },
  mounted() {
    const that = this;
    that.fetch();
  },
  methods: {
    fetch() {
      const that = this;
      const mymodal = sx.showWaiting()
      var params = {
        bucketid: "13",
        token: localStorage.getItem("token") || "token"
      }
      var url = that.$store.state.baseurl + '/app/cmshelper/fetchDocer'
      sx.request(
        url,
        params,
        function (result) {
          if (result.status === 'ok') {
            that.links = result.data.rows
            sx.hideWaiting(mymodal)
          } else {
            sx.toastSuccess(result.message)
            console.log(result.message)
            sx.hideWaiting(mymodal)
          }
        }
      )
      sx.hideWaiting()
    }
  }
}
</script>
